<template>
	<SOSlotModal
		:modal-id="pageSetting.modal.id"
		:modal-title="getTitle"
		@close="close"
	>
		<template v-slot:modal-body>
			<div>
				<MessageWrapper :text-message="getMessage" :category="'blast'" :preview-mode="isDrafted">
					<template v-slot:msg_head>
						<div class="d-flex-between-center" style="align-items: unset;" v-if="showMenu">
							<SOInputOnOff :checkboxes="getCheckbox" @selected="toogleOnOff" :checked="isDrafted" />
							<div class="bg-white" v-if="isEdit">
								<SOButton
									:outline="true"
									:text="'Ubah template'"
									:id="'confirm-register'"
									@action="gotoEdit"
								/>
							</div>
						</div>
					</template>
				</MessageWrapper>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import {moduleName} from "./../../store/state"
import {mapGetters, mapActions} from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import MessageWrapper from "@/modules/wa-autosender/components/MessageWrapper";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";
import SOButton from "@/so-components/global/ui/SOButton";

const previewMode = {
    id: "preview-mode",
    data: {
        name: "preview-mode",
        data: [
            {
                id: "preview-mode",
                value: "1",
                title: `<label class='f-regular f-14 f-c-black m-0' for='preview-mode'>Preview data</label>`,
                checked: false,
                titleBold: false,
            },
        ],
    },
};

export default {
	name: "ModalPreviewTemplatePesan",
	components: {
		SOSlotModal,
		MessageWrapper,
		SOInputOnOff,
		SOButton,
	},
	data() {
		return {
			pageSetting: {
				modal: {
					id: "",
				}
			},
            showMenu: false,
            isDrafted: false,
            isEdit: false,
		}
	},
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            detailTemplate: "detailTemplate",
        }),
        ...mapGetters("metaModule", {
            shortcode: "shortcode",
        }),
        getMessage() {
            return this.detailTemplate.template
        },
        getTitle() {
            return this.detailTemplate.nama
        },
        getCheckbox() {
            return previewMode.data;
        },
    },
	mounted() {
		this.pageSetting.modal.id = this.$route.params.id
		this.pageSetting.modal.title = this.$route.params.title
        this.showMenu = parseInt(this.$route.params.mode) > 1
        this.isEdit = parseInt(this.$route.params.mode) === 3
        this.fetchDetailTemplate(this.pageSetting.modal.id)
		setTimeout(() => {
			$("#" + this.pageSetting.modal.id).modal("show");
		}, 100)
	},
	methods: {
        ...mapActions({
            fetchDetailTemplate: `${moduleName}/fetchDetailTemplate`,
        }),
        toogleOnOff(val) {
            this.isDrafted = val;
        },
        gotoEdit() {
            this.$router.push({name: "wa_blast.template-pesan.edit"})
        },

		close() {
			$("#" + this.pageSetting.modal.id).modal("hide");
			setTimeout(() => {
				this.$router.back()
			}, 500)
		},
	}
}
</script>